import { DURATION_CONTEXT } from '../subscriptionTypes'

export type TDiscountPage = 'prices'

export type TDiscountRule = {
	period: `${DURATION_CONTEXT}`
	percentage: number
	page?: TDiscountPage
}

export const DISCOUNT_RULES: TDiscountRule[] = [
	{ period: DURATION_CONTEXT.WEEKS, percentage: 90 },
	{ period: DURATION_CONTEXT.YEARS, percentage: 61 },
	{ period: DURATION_CONTEXT.YEARS, percentage: 50, page: 'prices' },
]
